export default "__VITE_ASSET__84462040__"